<template>
    <div>
        <div class="capture warp"  id="captureId" v-show="firstFlag">
            <div class="left_inn">
                <div>
                    <img :src ="this.avatar" alt="" crossOrigin="anonymous" v-if="ashow">
                    <img src="../assets/touxinag.jpg" alt="" v-else>
                    <span>
                        <p>{{this.name}}</p>
                        <p>快速提升成绩的新方法</p> 
                    </span>
                    <div id="qrCode" ref="qrCodeDiv"></div>
                </div>
            </div> 
        </div>
        <img class="jieping" :src="dataURL" alt="" v-show="!firstFlag">
    </div>
</template>
<script>
import html2canvas from "html2canvas"
import QRCode from 'qrcodejs2'
export default {
    data(){
        return{
            dataURL:'',
            firstFlag:true,
            name:'',
            avatar:'',
            ashow:true,
            sshow:false
        }
    },
    beforeMount(){
        this.name = this.$route.query.name
        this.avatar = this.$route.query.avatar.replace("rjwpublic.oss-cn-qingdao.aliyuncs.com", 'rujiaowang.net')
        this.avatar = this.avatar.replace("http://rujiaowang", 'http://www.rujiaowang')
        console.log(this.avatar);
    },
    mounted() {
        new QRCode(this.$refs.qrCodeDiv, {
            text: "http://www.rujiaowang.net/",
            width: 76,
            height: 76,
            colorDark: "#333333", //二维码颜色
            colorLight: "#ffffff", //二维码背景色
        })
        
        html2canvas(document.querySelector('#captureId'),{
            allowTaint:true,
            useCORS: true
        }).then(canvas => {
            let imgUrl = canvas.toDataURL('image/png')
            this.dataURL = imgUrl
            this.firstFlag = false
        })
    },
    methods: {

    }
}

</script>

<style  scoped>
.warp{
    width: 100%;
    height: 600px;
    background: url("../assets/tuiguang.png") no-repeat;
    background-size:100% 100%;
    position: relative;
}
.left_inn>div:first-child{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 90%;
    padding: 0 5%;
}
.left_inn>div:first-child img,span{
    float: left;
}
.left_inn>div:first-child div{
    float: right;
}
.left_inn>div:first-child img {
    margin-top: 14px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
}
.left_inn>div:first-child span {
    display: inline-block;
    margin-left: 15px;
    font-size: 16px;
}
.left_inn>div:first-child p:last-child {
    font-size:14px;
}
.left_inn>div:first-child p{
    line-height: 30px;   
}
.jieping{
    width: 100%;
    height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/generalize.vue